import React, { Fragment } from 'react'
import PropTypes from 'prop-types'

const MultiSelector = ({
  cdMissionListLength = 0,
  setCdMissionList = () => {},
  setRemoveModal = () => {},
  attributesSelected = [],
  translate = () => {},
}) => {
  const renderOptions = () => {
    const list = [
      { label: 'remove', action: () => setRemoveModal(attributesSelected)},
      { label: 'cancel', action: () => setCdMissionList([]) },
    ]

    return list.map(({ label, action }) => (
      <Fragment key={label}>
        {' '}
        |{' '}
        <span onClick={action} style={{ color: '#72BF44', cursor: 'pointer' }}>
          {translate(`useConsumeApprovers.selection.${label}${cdMissionListLength > 1 ? 'Plural' : 'Singular'}`)}
        </span>
      </Fragment>
    ))
  }

  return (
    <div className='mission-block-action-mode'>
      {cdMissionListLength > 0 && (
        <div style={{ marginTop: '1rem' }}>
          <strong>
            {`${cdMissionListLength} 
              ${ translate(
                `useConsumeApprovers.selection.quantity${
                  cdMissionListLength > 1 ? 'Plural' : 'Singular'
                  }`)
              }`
            }
          </strong>
          {renderOptions()}
        </div>
      ) }
    </div>
  )
}

MultiSelector.propTypes = {
  cdMissionListLength: PropTypes.number.isRequired,
  handleSideFilterMenuCollapseChange: PropTypes.func.isRequired,
  setCdMissionList: PropTypes.func.isRequired,
  sideFilterVisible: PropTypes.bool.isRequired,
  translate: PropTypes.func.isRequired,
  setRemoveModal: PropTypes.func.isRequired,
  attributesSelected: PropTypes.array
}

export default MultiSelector
